import React, { useMemo, useRef } from 'react';

import startOfDay from 'date-fns/startOfDay';

import {
  useDateFilter,
  useDepartmentFilter,
  usePositionFilter,
} from '@sbv-clients/domain-ui-shared';

const pageKey = 'WorkforceDashboard';

export const useDashboardContext = () => {
  const defaultDate = useRef(new Date()).current;
  const [departmentId, setDepartmentId] = useDepartmentFilter(pageKey);
  const [positionId, setPositionId] = usePositionFilter(pageKey);

  const [date, setDate] = useDateFilter(pageKey, defaultDate);

  const { startDate, endDate } = useMemo(
    () => ({
      startDate: date ? startOfDay(new Date(date as any)) : defaultDate,
      endDate: date ? startOfDay(new Date(date as any)) : defaultDate,
    }),
    [date, defaultDate]
  );

  return useMemo(
    () => ({
      date,
      setDate,
      departmentId,
      setDepartmentId,
      positionId,
      setPositionId,
      startDate,
      endDate,
    }),
    [
      date,
      departmentId,
      endDate,
      positionId,
      setDate,
      setDepartmentId,
      setPositionId,
      startDate,
    ]
  );
};

export type DashboardContextType = ReturnType<typeof useDashboardContext>;
export const DashboardContext =
  React.createContext<DashboardContextType | null>(null);
